import { extend } from 'underscore';
import React from 'react';

export function withPageName(Component, pageName) {
  const ComponentWithPageName = props => (
    <Component pageName={pageName} {...props} />
  );

  extend(ComponentWithPageName, { pageName });

  return ComponentWithPageName;
}
